module.exports = __webpack_public_path__ + "images/store_case_study/mlmkaitoricocotop-pic1_7e13488d7b073f457547b756f0a4d328.jpg";